import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { DTOWorkspaceTranserOwnershipProposal } from '@shared/dto/+workspace/workspace_transfer_ownership_proposal/dto_workspace_transfer_ownership_proposal';
import { STATE__workspace } from '../STATE__workspace';

export const local_workspace_transfer_ownership_proposal_upsert = (
  payload: DTOWorkspaceTranserOwnershipProposal[],
): PayloadAction<DTOWorkspaceTranserOwnershipProposal[]> => ({
  type: ENUM__redux_action.WORKSPACE_TRANSFER_OWNERSHIP_PROPOSAL_UPSERT,
  payload,
});

export const init_local_workspace_transfer_ownership_proposal_upsert = (
  state: STATE__workspace,
  action: PayloadAction<DTOWorkspaceTranserOwnershipProposal[]>,
) => {
  if (action.payload.is_empty()) return;

  for (let item of action.payload) {
    state.transfer_ownership_proposals_map.set(item._id, item);
  }

  //refresh map to trigger re-render
  state.transfer_ownership_proposals_map = new Map(state.transfer_ownership_proposals_map);
};
